import { useEffect, useState } from "react";

import { apiUrl } from "../lib/config";
import {
  PORTAL_HOST,
  MARKETING_HOST,
  UNRESOLVED_HOST,
  resolvePortalHostSync,
} from "../lib/portalHost";

// Resolves whether to render the Data API portal for the current host.
//
// Known hosts resolve synchronously (no flash, no network). An unknown host is probed once against
// the public branding endpoint: a 200 means it maps to an active reseller portal domain; anything
// else (404, CORS/network error) falls back to the marketing site. On success we persist the
// session flag so a reload of the same host is instant.
//
// Deliberately a bare fetch — it does NOT import the dataApi service layer, so the marketing bundle
// stays lean and DataApiApp remains lazy-loaded.
export const usePortalHostDecision = () => {
  const [decision, setDecision] = useState(resolvePortalHostSync);

  useEffect(() => {
    if (decision !== UNRESOLVED_HOST) {
      return undefined;
    }

    const controller = new AbortController();
    const host = window.location.hostname.toLowerCase();

    fetch(`${apiUrl}/v1/portal/branding?host=${encodeURIComponent(host)}`, {
      signal: controller.signal,
    })
      .then((res) => {
        if (res.ok) {
          try {
            window.sessionStorage.setItem("dataapi", "1");
          } catch {
            // ignore storage failures; the decision still applies for this load.
          }
          setDecision(PORTAL_HOST);
        } else {
          setDecision(MARKETING_HOST);
        }
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          setDecision(MARKETING_HOST);
        }
      });

    return () => controller.abort();
  }, [decision]);

  return decision;
};
